import { render, staticRenderFns } from "./inActiveMarket.vue?vue&type=template&id=2d790bc0"
import script from "./inActiveMarket.vue?vue&type=script&lang=js"
export * from "./inActiveMarket.vue?vue&type=script&lang=js"
import style0 from "./inActiveMarket.vue?vue&type=style&index=0&id=2d790bc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports